var map = {
	"./header-en.jpg": 507,
	"./header-es.jpg": 508
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 506;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/header\-.*\.jpg$
// module id = 506
// module chunks = 1 2 3 4 5 6